
export const ReportBoxContainer = {
    padding: "20px 10px",
    boxSizing: "border-box",
    height: "100vh"
}
export const ButtonBoxContainer = {
    display: "flex",
    justifyContent: "flex-end",
}

export const ReportsPageContainer = {
    display: "flex",
    flexWrap: "wrap",
    gap: "5%",
    rowGap: 2
}